<template>
    <NavSlider
        :items="items"
        :activeItemId="activeItemId"
        @itemClick="onNavItemClick"
    />
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import NavSlider from '@app/mobile/components/NavSlider/NavSlider';
    import { capitalize } from '@modules/shared/filters';

    export default {
        computed: {
            ...mapGetters('ui/sportOffer/sports', [
                'sportsFilter',
                'selectedTreeItem',
            ]),
            activeItemId() {
                return this.selectedTreeItem.id;
            },
            items() {
                return this.sportsFilter.map(({
                    id,
                    label,
                }) => ({
                    id,
                    label: capitalize(label),
                }));
            }
        },
        methods: {
            ...mapActions('ui/sportOffer/sports', [
                'setSelectedTreeItem',
            ]),
            onNavItemClick({ id, label }) {
                this.setSelectedTreeItem([{ id, name: label }]);
            },
        },
        components: {
            NavSlider,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/mobile/sportOffer/LiveSubNav.vue